import { layoutMarginSmall, ProductButton, ProductHeading } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { breakpointWidths } from '../../../constants';
import { Description } from '../../DocumentDetails/Description';
import DocumentContext from '../../DocumentPage/DocumentContext';

const NextRoot = styled.div`
    padding: ${layoutMarginSmall};
    width: 38em;
`;

const NextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${layoutMarginSmall};
`;

const ButtonWrapper = styled.div`
    text-align: center;
    margin-bottom: ${layoutMarginSmall};
`;

const CoverContainer = styled.div`
    img {
        min-width: 6.25em;
        max-width: 100%;
        max-height: 8em;
        height: 100%;
    }

    @media (max-width: ${breakpointWidths.smallMax}px) {
        display: none;
    }
`;

const DocInfo = styled.div`
    padding-left: ${layoutMarginSmall};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @media (max-width: ${breakpointWidths.smallMax}px) {
        text-align: center;
        align-items: center;
    }
`;

type Props = {
    onClose: () => void;
    countdownSecs: number;
};

export const NextDoc: React.FC<Props> = ({ onClose, countdownSecs }) => {
    const { document, hosts } = useContext(DocumentContext);

    const imageUrl = `https://${hosts.image}/${document.revisionId}-${document.publicationId}/jpg/page_1_thumb_large.jpg`;

    return (
        <NextRoot>
            <NextWrapper>
                <CoverContainer>
                    <img src={imageUrl} />
                </CoverContainer>
                <DocInfo>
                    <ProductHeading level={5}>{document.title}</ProductHeading>
                    <Description />
                </DocInfo>
            </NextWrapper>
            <ButtonWrapper>
                {countdownSecs <= 0 ? (
                    <ProductButton onClick={onClose} role="link" variant="primary">
                        Publication Ready
                    </ProductButton>
                ) : (
                    <ProductButton disabled role="link" variant="primary">
                        Publication loading ({countdownSecs})
                    </ProductButton>
                )}
            </ButtonWrapper>
        </NextRoot>
    );
};
